import camelcaseKeys from 'camelcase-keys'

export class Station {
  constructor (params = {}) {
    const { id, sequence, externalIds, name, zoneId, material_loanIds, accessAreaIds, allowedCurrencyIds, allowedPaymentMethodIds, catalogId, ticketTemplateFileId } = params ? camelcaseKeys(params, { deep: true }) : {}
    this.id = id || null
    this.name = name || null
    this.sequence = sequence
    this.zoneId = zoneId || null
    this.externalIds = externalIds
    this.catalogId = catalogId || null
    this.accessAreaIds = accessAreaIds || null
    this.material_loanIds = material_loanIds || null
    this.allowedCurrencyIds = allowedCurrencyIds || null
    this.ticketTemplateFileId = ticketTemplateFileId || null
    this.allowedPaymentMethodIds = allowedPaymentMethodIds || null
  }
}